import { schema } from 'normalizr';
import facebookLifetimeInsightSchema from './facebookLifetimeInsightSchema';

const facebookAdsetSchema = new schema.Entity('facebookAdsets', {
  adsLifetimeInsights: [facebookLifetimeInsightSchema],
});

export default facebookAdsetSchema;
